import * as THREE from 'three'
import type { GSplatVector3Input } from './effectUtils'
import { createVector3 } from './effectUtils'
import type { GSplatShaderEffectOptions } from './GSplatShaderEffect'
import { GSplatShaderEffect } from './GSplatShaderEffect'

export interface GSplatVisualShowcaseEffectOptions extends GSplatShaderEffectOptions {
  center?: GSplatVector3Input
  intensity?: number
  timeScale?: number
  effectScale?: number
}

export interface GSplatVisualShowcaseEffectConfig {
  id: string
  shader: string
  shaderWGSL?: string
}

export abstract class GSplatVisualShowcaseEffect extends GSplatShaderEffect {
  private readonly _center: THREE.Vector3
  private readonly _intensity: number
  private readonly _timeScale: number
  private readonly _effectScale: number
  private readonly _shader: string
  private readonly _shaderWGSL: string | null

  protected constructor(
    config: GSplatVisualShowcaseEffectConfig,
    options: GSplatVisualShowcaseEffectOptions = {}
  ) {
    super({
      ...options,
      id: options.id ?? config.id,
    })

    this._center = createVector3(options.center, new THREE.Vector3())
    this._intensity = options.intensity ?? 1
    this._timeScale = options.timeScale ?? 1
    this._effectScale = Math.max(0.001, options.effectScale ?? 1)
    this._shader = config.shader
    this._shaderWGSL = config.shaderWGSL ?? null
  }

  override getShaderGLSL(): string {
    return this._shader
  }

  override getShaderWGSL(): string | null {
    return this._shaderWGSL
  }

  protected override updateEffect(effectTime: number): void {
    this.setUniform('uTime', effectTime)
    this.setUniform('uTimeScale', this._timeScale)
    this.setUniform('uIntensity', this._intensity)
    this.setUniform('uCenter', this._center)
    this.setUniform('uEffectScale', this._effectScale)
  }
}
